import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard
} from '@bepatient/core';
import {
  selectorTimelineDays,
  TimelineActionLoadTimeline
} from '@bepatient/timeline-store';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { ActivityComponent } from './components/activity/activity.component';
import { InfoMessageComponent } from './components/info-message/info-message.component';

@Injectable()
export class TimelineGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorTimelineDays, new TimelineActionLoadTimeline());
  }
}

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.TIMELINE,
  i18nLabel: 'MODULES.TIMELINE',
  icon: 'clock',
  leftMenuAvailableForPages: [0, 1, 2, 3],
  routes: [
    {
      path: 'timeline',
      canActivate: [TimelineGuard],
      loadChildren: () =>
        import('./pages/timeline/timeline.module').then(
          m => m.TimelinePageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    TimelineGuard,
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './timeline/i18n/', multi: true }
  ],
  exports: [InfoMessageComponent, ActivityComponent],
  declarations: [InfoMessageComponent, ActivityComponent]
})
export class TimelineModule {}
